import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { instrumentType, instrumentTypes } from '../../utils/instrumentTypes';

enum Texts {
  instrumentType = 'Tipo de instrumento o producto',
  instrumentNumber = 'Número del instrumento o producto',
  agency = 'Agencia de apertura',
  openingDate = 'Fecha de apertura',
  deadline = 'Fecha de cierre',
  title = 'Descripción del instrumento o producto asociado a la operacion reportada',
}

@Component({
  selector: 'instrument-description',
  templateUrl: './instrument-description.component.html',
  styleUrls: ['./instrument-description.component.scss'],
})
export class InstrumentDescriptionComponent implements OnInit {
  public Texts = Texts;
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();

  public instrumentTypes = instrumentTypes;
  requireds: boolean = false;

  get instrumentDescription() {
    return this.form.get('instrumentDescription') as FormGroup;
  }
  get instrumentNumber() {
    return this.instrumentDescription.get('instrumentNumber');
  }

  get instrumentType() {
    return this.instrumentDescription.get('instrumentType');
  }
  get agency() {
    return this.instrumentDescription.get('agency');
  }
  get openingDate() {
    return this.instrumentDescription.get('openingDate');
  }

  instrumentChange() {
    const value: number = this.instrumentType.value;

    if (value != 0) {
      this.requireds = true;
      this.instrumentNumber.setValidators([Validators.required]);
      this.agency.setValidators([Validators.required]);
      this.openingDate.setValidators([Validators.required]);
    } else {
      this.requireds = false;
      this.instrumentNumber.clearValidators();
      this.agency.clearValidators();
      this.openingDate.clearValidators();
    }
    this.instrumentNumber.updateValueAndValidity();
    this.agency.updateValueAndValidity();
    this.openingDate.updateValueAndValidity();
    this.formChange.emit(this.form);
  }

  constructor() {}

  ngOnInit() {}
}
